import AppSidebar from "@/components/custom-ui/sidebar/app.sidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { cn } from "@/lib/utils";
import { sidebarNavigation } from "@/pages/routs.menu";
import { FC, Suspense } from "react";
import { Outlet } from "react-router-dom";
import HeaderLayout from "./components/custom-ui/header.layout";
import { LoadingSpinner } from "./components/custom-ui/loading.spinner";
import { Separator } from "./components/ui/separator";
import Inactive from "./pages/shared/inactive";
import { useUserStore } from "./store/user";
// import { useAlertSSE } from "./hooks/useAlertSSE";

const MainLayout: FC = () => {
  const isActiveUser = useUserStore((store) => store.user.isActivate);

  const navigationLinks = sidebarNavigation;
  // const isSidebarVisible = useToggleStore((store) => store.isSidebarVisible);
  // const accessToken = useUserStore((store) => store.getAccessToken());
  // useAlertSSE({ accessToken });
  //TODO: Исправить на нормальную реализацию

  // Если пользователь не активен, сразу возвращаем компонент Inactive
  if (!isActiveUser) {
    return <Inactive />;
  }

  // return (
  //   <div className="flex h-screen overflow-x-hidden">
  //     <AppSidebar navigationLinks={navigationLinks} variant="inset" />
  //     <SidebarInset>
  //     <div className=" h-screen w-full rounded-l-xl  flex flex-col">
  //       <HeaderLayout />
  //       <Separator />
  //       <main
  //         className={`flex-1 m-2 p-2 overflow-hidden transition-width duration-300   `}
  //       >
  //         <Suspense
  //           fallback={
  //             <div className="flex justify-center items-center min-h-full min-w-full">
  //               <LoadingSpinner />
  //             </div>
  //           }
  //         >
  //           <Outlet />
  //         </Suspense>
  //         <Toaster />
  //       </main>
  //     </div>
  //     </SidebarInset>
  //   </div>
  // );
  return (
    <SidebarProvider>
      <AppSidebar navigationLinks={navigationLinks} />
      <div className="w-full h-screen overflow-auto flex flex-col  ">
        <HeaderLayout className={cn(" shrink-0 ")} />
        <Separator />
        <main className="flex flex-col flex-1 min-h-0 p-2 overflow-hidden">
          <Suspense
            fallback={
              <div className="flex justify-center items-center min-h-full min-w-full">
                <LoadingSpinner />
              </div>
            }
          >
            <Outlet />
          </Suspense>

          <Toaster />
        </main>
      </div>
    </SidebarProvider>
  );
};

export default MainLayout;
